export const enum TransactionType {
    FanToken = 'fan_token',
    Main = 'main'
}

export const enum TransactionBatchType {
    KycCumulativeLimit = 'kyc_cumulative_limit',
    Withdrawal = 'withdrawal',
    MarketplacePurchase = 'marketplace_purchase',
    Bonus = 'bonus',
    MarketplaceSale = 'marketplace_sale',
    Buy = 'buy',
    Deposit = 'deposit',
    RegulatoryRestriction = 'regulatory_restriction',
}

export const enum TransactionInternalType {
    Unlock = 'unlock',
}